import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, NavigationError, RouterEvent } from '@angular/router';

import { PaymentService } from './../../rest/api/payment.service';
import { PaymentService as PaymentLocalService } from './../../services/payment/payment.service';
import { AuthService } from './../../services/auth.service';
import { MemberService } from './../../rest/api/member.service';
import {TranslateService} from '@ngx-translate/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  accessToken: any;

  loading: boolean;
  currentRoute: any;
  plansData: any;

  // current plans
  subscriptionData: any;
  currentSubscription: any;
  currentPlansData: any;
  cameraSubscription: any;
  subscriptionLoader = true;

  lang: any;

  constructor(
    private router: Router,
    public paymentService: PaymentService,
    public paymentLocalService: PaymentLocalService,
    public authService: AuthService,
    public translateService: TranslateService,
    public memberService: MemberService
  ) {

    const status = this.authService.getSubscriptionStatus();
    if (status && status === 'active') {
      this.router.navigate(['/member']);
    }
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;

    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getPlans();
    this.getCurrentSubscription();
  }

  getCurrentSubscription() {
    this.memberService.getCurrentSubscription(this.accessToken).subscribe((response: any) => {
      this.subscriptionData = response && response.data ? response.data : undefined;
      this.currentPlansData = this.subscriptionData && this.subscriptionData.plans && this.subscriptionData.plans[0] ? this.subscriptionData.plans : [];
      this.currentSubscription = this.currentPlansData ? _.find(this.currentPlansData, {type: 'subscription'}) : undefined;
      this.cameraSubscription = this.currentPlansData ? _.find(this.currentPlansData, {type: 'camera'}) : undefined;
      this.subscriptionLoader = false;
    }, err => {
      this.subscriptionLoader = false;
    });
  }

  getPlans() {
    this.paymentService.paymentRenewInfo({
      Authorization: this.accessToken,
      lang: this.lang
    }).subscribe((response: any) => {
      this.plansData = response && response.plan ? response.plan : [];
      this.paymentLocalService.setCardPlan(this.plansData);
    });
  }

  private navigationInterceptor(event: RouterEvent): void {
    this.loading = true;
    let timer: any = null;

    if (event instanceof NavigationStart) {
      clearTimeout( timer );
      timer = setTimeout((): void => {
          this.loading = false;
      }, 1000);
    }

    if (event instanceof NavigationEnd) {
      this.currentRoute = event.url;
      clearTimeout( timer );
      timer = setTimeout((): void => {
          this.loading = false;
      }, 1000);
    }

    if (event instanceof NavigationCancel) {
      this.loading = false;
    }

    if (event instanceof NavigationError) {
      this.loading = false;
    }

  }

}
